import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_bgc--light _rounded--common _flex _ai-c _gap-3 _pa-3 _tc--dark",
  "data-qa": "available-gift-cards"
}
const _hoisted_2 = {
  "format-key": "0",
  "data-qa": "available-gift-cards:Amount"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")

  return ($setup.giftCardBalance > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_icon, {
          name: "gift-card",
          size: "3x",
          class: "_tc--light _shrink-0"
        }),
        _createVNode(_component_localize, {
          resource: _ctx.Resources.YourPledge.AvailableGiftCardsDescription
        }, {
          default: _withCtx(() => [
            _createElementVNode("strong", _hoisted_2, _toDisplayString($options.formattedGiftCardBalanceText), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ]))
    : _createCommentVNode("v-if", true)
}